/* eslint-disable prefer-const */
/* eslint-disable no-fallthrough */
import { Injectable } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { DataUserService } from '../servicios/data-user-servicios';
import { LogService } from "../servicios/log-servicios";
import { Articulo } from '../interfaces/articulo-interfaces';
import { Paciente, PacienteIndice } from '../interfaces/paciente-interfaces';
import { EntDiag, EntProc, EntPres } from '../interfaces/entcons-interfaces';
import { Estilo } from "../interfaces/varias-interfaces";
import { Atiende } from '../interfaces/atiende-interfaces';

@Injectable({
  providedIn: 'root'
})
export class FuncionesService {
  constructor(
    private dataUserService: DataUserService,
    private logService: LogService
  ) { }

  isObject(object: object): boolean {
    return object != null && typeof object === "object";
  }

  // T es un tipo para que esta rutina sirva para cualquier tipo de objeto
  copiarArregloDeObjetos<T>(arr1: Array<T>): Array<T> {
    let arr2: Array<T> = [];
    for (let i = 0; i < arr1.length; i++) {
      const obj1 = arr1[i];
      let obj2: T = Object.assign({}, obj1)
      arr2.push(obj2);
    }
    return arr2;
  }

  deepEqual(object1: object, object2: object) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = this.isObject(val1) && this.isObject(val2);
      if (
        (areObjects && !this.deepEqual(val1, val2)) ||
        (!areObjects && val1 !== val2)
      ) {
        return false;
      }
    }
    return true;
  }

  compareStr(p1: string, p2: string): boolean {
    const b: boolean = p1 == p2;
    this.logService.consoleLog('2', 'compareStr: ');
    this.logService.consoleLog('2', b ? 'true' : 'false');
    return b;
  }

  reemplazaTodoEnString(tipoXmlPdf: string, strTextoOriginal: string, objTradChar: object): string {
    //tipoXmlPdf puede ser XML o cualquier otro como PDF o NombreArch. 
    //Si es XML no cambia la palabra RÉGIMEN en casos especiales, revisar ficha técnica.
    //objTradChar es un objeto con pares 'texto a reemplazar': 'reemplazo'
    //2022/11/08: compruebo que EN EASYMED NO HACE FALTA CAMBIAR LOS CARACTERES ESPECIALES DEL XML, pues el archivo va codificado en UTF-8
    //El problema en Efisys se debe a que va codificado en ANSI.
    //Finalmente solo uso esta rutina para quitar caracteres de los títulos
    let retStr: string = strTextoOriginal;
    if (tipoXmlPdf == 'XML') {
      retStr = retStr.replace('CONTRIBUYENTE NEGOCIO POPULAR - RÉGIMEN RIMPE', 'CONTRIBUYENTE NEGOCIO POPULAR - RxGIMEN RIMPE');
      retStr = retStr.replace('CONTRIBUYENTE RÉGIMEN RIMPE', 'CONTRIBUYENTE RxGIMEN RIMPE');
      retStr = retStr.replace('CONTRIBUYENTE RÉGIMEN MICROEMPRESAS', 'CONTRIBUYENTE RxGIMEN MICROEMPRESAS');
    }
    for (const x in objTradChar) {
      retStr = retStr.replace(new RegExp(x, 'g'), objTradChar[x]);
    }
    if (tipoXmlPdf == 'XML') {
      retStr = retStr.replace('CONTRIBUYENTE NEGOCIO POPULAR - RxGIMEN RIMPE', 'CONTRIBUYENTE NEGOCIO POPULAR - RÉGIMEN RIMPE');
      retStr = retStr.replace('CONTRIBUYENTE RxGIMEN RIMPE', 'CONTRIBUYENTE RÉGIMEN RIMPE');
      retStr = retStr.replace('CONTRIBUYENTE RxGIMEN MICROEMPRESAS', 'CONTRIBUYENTE RÉGIMEN MICROEMPRESAS');
    }
    return retStr;
  }

  formateaTextoEnVariasLineas(texto: string, largo: number): string[] {
    const arreglo: string[] = [];
    let seguir: boolean = true;
    let textoRestante: string = texto.slice();  //para asegurar que sea un nuevo string
    while (seguir) {
      if (textoRestante.length <= largo) {
        //si el textoRestante es corto, lo guardo en el arreglo y salgo del while
        arreglo.push(textoRestante);
        seguir = false;
      } else {
        //si el textoRestante supera el largo indicado
        const a: string = textoRestante.slice(0, largo);  //fragmento del largo máximo permitido
        let ultimoEspacio: number = 0;
        if (textoRestante.slice(largo, largo + 1) == ' ') {
          //si hay un espacio luego del fragmento: la última palabra entró exacta en el fragmento
          ultimoEspacio = largo;
          arreglo.push(a);
          textoRestante = textoRestante.slice(ultimoEspacio + 1);
        } else {
          //si la palabra quedó truncada
          ultimoEspacio = a.lastIndexOf(" ");
          arreglo.push(textoRestante.slice(0, ultimoEspacio));
          textoRestante = textoRestante.slice(ultimoEspacio + 1);
        }
      }
    }
    return arreglo;
  }

  findInvalidControls(f: FormGroup): string[] {
    const invalid = [];
    const controls = f.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  chkValido(f: FormGroup, nombre: string): boolean {
    let valido = true;
    const controls = f.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        if (name == nombre) {
          valido = false;
        }
      }
    }
    return valido;
  }

  aplicaTema(tema: Estilo[]) {
    for (let i = 0; i < tema.length; i++) {
      const est = tema[i];
      this.logService.consoleLog('2', "Prueba temas");
      //this.esteComponente = document.querySelector("app-paciente-com-consulta");
      const docStyle = document.documentElement.style;
      //const docStyle = this.esteComponente.style;
      docStyle.setProperty('--' + est.atributo, est.valor);
    }
  }

  aplicaExtraSize(extra: string) {
    const docStyle = document.documentElement.style;
    docStyle.setProperty('--extrasize', extra);
  }

  asignaEstiloAlerta(nivel: string): object {
    let estilo = {};
    estilo = { "background": "#f8f8f8", "color": "black" };
    switch (nivel) {
      case 'PROBLEMA':
        estilo = { "background": "red", "color": "yellow" };
        break;
      case 'ATENCION':
        estilo = { "background": "orange", "color": "black" };
        break;
      case 'INFORMACION':
        estilo = { "background": "#f8f8f8", "color": "black" };
        break;
    }
    return estilo;
  }

  asignaEstiloMensaje(nivel: string, esFacConDevolOEsNc: boolean): object {
    let estilo = {};
    estilo = { "background": "#f8f8f8", "color": "black" };
    switch (nivel) {
      case 'NORMAL':
        if (esFacConDevolOEsNc) {
          estilo = { "background": "#f8f8f8", "color": "black", "font-size": "10px" };
        } else {
          estilo = { "background": "#f8f8f8", "color": "black", "font-size": "12px" };
        }
        break;
      case 'IMPORTANTE':
        estilo = { "background": "#c0ffe0", "color": "blue", "font-weight": "600" };
        break;
    }
    return estilo;
  }

  asignaEstiloEstado(estado: string): object {
    let estilo = {};
    estilo = { "background": "#f8f8f8", "color": "black" };

    switch (estado) {
      //DIGITANDO
      case '000: Digitando':
        estilo = { "background": "#f8f8f8", "color": "black" };
        break;
      //ANULADA
      case '020: Anulada':
        estilo = { "background": "#c0c0c0", "color": "black", "font-weight": "600" };
        break;
      //PROCESADA
      case '030: EnviadaOK':
        estilo = { "background": "#c0ffe0", "color": "blue", "font-weight": "600" };
        break;

      //ALERTA AMARILLA: Se habilita el botón Continuar
      //Errores temporales:
      case '340: XML En Espera':
      case '923: Err Conexión 1 SRI':
      case '960: Err Conexión 2 SRI':
      case '980: Err Envío Mail':
      //Errores consecuencia de errores temporales:
      case '335: Clave Reg':
      //Estados de paso, no debería quedarse aquí:
      case '300: Inicia Proceso':
      case '310: XML Gen':
      case '320: XML Fir':
      case '330: XML Rec':
      case '350: XML Aut':
      case '350: XML AUT':
      case '355: TxtPDF Gen':
      case '360: PDF Gen':
        estilo = { "background": "#ffff00", "color": "red", "font-weight": "600" };
        break;

      //ALERTA ROJA: No se habilita el botón Continuar
      //Errores sin mensaje claro:
      case '905: Err creaXml':
      case '910: Err Firma':
      case '920: Err Envío':
      case '940: Err Verificar':
      case '999: Error General':
      //Errores con mensaje claro:
      case '921: Err 3 Intentos':
      case '922: Err Extemp':
      case '924: Err Clave NA':
      case '925: Err RUC No Existe':
      case '926: Err No Válido':
      case '927: Err Estruc XML':
      case '938: Err Desconocido':
      case '939: Rechazada':
      case '950: No Autorizada':
      case '951: Err Estab Cerrado':
      case '952: Err Firma Inválida':
      case '970: Err Txt PDF':
      case '972: Err Gen PDF':
        estilo = { "background": "#ff8000", "color": "yellow", "font-weight": "600" };
        break;
      default:
        //Esto debería ser un error, un estado mal escrito o no considerado
        estilo = { "background": "#000000", "color": "white", "font-weight": "600" };
        break;
    }
    return estilo;
  }

  asignaEstiloTipoDoc(tipodoc: string): object {
    let estilo = {};
    estilo = { "background": "#3898EC" };   //sirve como default

    switch (tipodoc) {
      case 'FAC':
        estilo = { "background": "#3898EC" };
        break;
      case 'NC':
        estilo = { "background": "#00d000" };
        break;
    }
    return estilo;
  }

  asignaEstiloActTipo(columna: string, tipo: string): object {
    let estilo = {};
    estilo = { "background": "white" };   //sirve como default

    switch (columna) {
      case '#':
        estilo = { "background": "#3898EC" };   //sirve como default
        break;
      case 'aTipo':
        switch (tipo) {
          case 'CONSULTA':
            estilo = { "background": "aliceblue" };
            break;
          case 'FACTURA':
            estilo = { "background": "antiquewhite" };
            break;
          case 'COBRO':
            estilo = { "background": "aquamarine" };
            break;
          case 'MOVCAJA':
            estilo = { "background": "palegoldenrod" };
            break;
        }
        break;
      case 'Consulta':
        switch (tipo) {
          case 'CONSULTA':
            estilo = { "background": "aliceblue" };
            break;
        }
        break;
      case 'ConsFac':
        switch (tipo) {
          case 'CONSULTA':
            estilo = { "background": "aliceblue" };
            break;
          case 'FACTURA':
            estilo = { "background": "antiquewhite" };
            break;
        }
        break;
      case 'Factura':
        switch (tipo) {
          case 'FACTURA':
            estilo = { "background": "antiquewhite" };
            break;
        }
        break;
      case 'FacCob':
        switch (tipo) {
          case 'FACTURA':
            estilo = { "background": "antiquewhite" };
            break;
          case 'COBRO':
            estilo = { "background": "aquamarine" };
            break;
        }
        break;
      case 'CobMov':
        switch (tipo) {
          case 'COBRO':
            estilo = { "background": "aquamarine" };
            break;
          case 'MOVCAJA':
            estilo = { "background": "palegoldenrod" };
            break;
        }
        break;
      case 'Cobro':
        switch (tipo) {
          case 'COBRO':
            estilo = { "background": "aquamarine" };
            break;
        }
        break;
      default:
        break;
    }
    return estilo;
  }

  asignaEstiloActDetTipo(actDetTipo: string): object {
    let estilo = {};
    estilo = { "background": "#3898EC" };   //sirve como default

    switch (actDetTipo) {
      case 'Consulta':
      case 'Procedimiento ':
        estilo = { "background": "#3898EC" };
        break;
      case 'Servicio x Facturar':
      case 'IVA':
        estilo = { "background": "#00d000" };
        break;
      case 'CxC':
        estilo = { "background": "#d04040" };
        break;
      case 'Cobro':
        estilo = { "background": "#f2d4a6" };
        break;
    }
    return estilo;
  }

  asignaEstiloActEstado(estado: string): object {
    let estilo = {};
    estilo = { "background": "#f8f8f8", "color": "black" };

    switch (estado) {
      case 'P':
        estilo = { "background": "white", "color": "black", "font-weight": "600" };
        break;
      case 'A':
        estilo = { "background": "yellow", "color": "red", "font-weight": "600" };
        break;
      default:
        //Esto debería ser un error, un estado mal escrito o no considerado
        estilo = { "background": "white", "color": "black", "font-weight": "600" };
        break;
    }
    return estilo;
  }

  asignaEstilo(f: FormGroup, nombre: string, invalidExterno?: boolean): object {
    //this.logService.consoleLog('2','CS FN nombre: ' + nombre);
    //this.logService.consoleLog('2','CS FN value: ' + f.controls[nombre].value);
    let estilo = {};
    estilo = { "background": "#ffffff" };   //original #fff9e0 celeste #e8f0fe amarillo claro #fffff0
    const controls = f.controls;
    const invExt: boolean = invalidExterno || false;
    if (controls[nombre].invalid || invExt) {
      //this.logService.consoleLog('2',"CS FN Inválido: " + nombre);
      estilo = { "color": "red", "background": "#fccfa4" };
    }
    if (controls[nombre].disabled) {
      estilo = { "background": "lightgrey" };
    }
    return estilo;
  }

  asignaEstiloSubmitDisabled(f: FormGroup): object {
    let estilo = {};
    estilo = { "background": "#3898ec", "color": "#fff" };
    const controls = f.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        //this.logService.consoleLog('2',"CS FN Inválido: " + nombre);
        estilo = { "background": "#a8b8ec", "color": "#ddd" }; //c8e8ec
      }
    }
    return estilo;
  }

  asignaEstiloSubmitDisabledFacProc(f: FormGroup, habil: boolean): object {
    let estilo = {};
    estilo = { "background": "#f0ffff", "color": "#fff", cursor: "pointer" };   //#3898ec
    const controls = f.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        //this.logService.consoleLog('2',"CS FN Inválido: " + nombre);
        estilo = { "background": "#a8b8ec", "color": "#d0d0d0", cursor: "not-allowed" }; //c8e8ec
      }
    }
    if (!habil) {
      estilo = { "background": "#a8b8ec", "color": "#d0d0d0", cursor: "not-allowed" }; //c8e8ec
    }
    return estilo;
  }

  esFormValido(f: FormGroup): boolean {
    let valido: boolean = true;
    const controls = f.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        //this.logService.consoleLog('2',"CS FN Inválido: " + nombre);
        valido = false;
      }
    }
    return valido;
  }

  asignaEstiloSubmitDisabledFacGrab(f: FormGroup, habil: boolean): object {
    let estilo = {};
    estilo = { "background": "#f0ffff", "color": "#fff", cursor: "pointer" };   //#3898ec
    if (!habil) {
      estilo = { "background": "#a8b8ec", "color": "#d0d0d0", cursor: "not-allowed" }; //c8e8ec
    }
    return estilo;
  }

  asignaEstiloSubmitDisabledFacAnul(f: FormGroup, habil: boolean): object {
    let estilo = {};
    estilo = { "background": "#f0ffff", "color": "#fff", cursor: "pointer" };   //#3898ec
    if (!habil) {
      estilo = { "background": "#a8b8ec", "color": "#d0d0d0", cursor: "not-allowed" }; //c8e8ec
    }
    return estilo;
  }

  asignaEstiloNuevoDetDisabled(deshabilitar: boolean): object {
    let estilo = {};
    estilo = { "background": "#3898ec", "color": "#fff", cursor: "pointer" };
    if (deshabilitar) {
      estilo = { "background": "#a8b8ec", "color": "#d0d0d0", cursor: "not-allowed" }; //c8e8ec
    }
    return estilo;
  }

  asignaEstiloElimDetDisabled(deshabilitar: boolean): object {
    let estilo = {};
    estilo = { "background": "#3898ec", "color": "#fff", cursor: "pointer" };
    if (deshabilitar) {
      estilo = { "background": "#a8b8ec", "color": "#d0d0d0", cursor: "not-allowed" }; //c8e8ec
    }
    return estilo;
  }

  asignaEstiloPDFXMLDisabled(deshabilitar: boolean): object {
    let estilo = {};
    estilo = { "background": "#3898ec", "color": "#fff", "cursor": "pointer", "pointer-events": "all" };
    if (deshabilitar) {
      estilo = { "background": "#a8b8ec", "color": "#d0d0d0", "cursor": "not-allowed", "pointer-events": "none" }; //c8e8ec
    }
    return estilo;
  }

  ordenarArregloDeTextos(arreglo: string[], orden1: string) {
    arreglo.sort((a: string, b: string) => {
      if (a.toUpperCase() > b.toUpperCase()) {
        if (orden1 == 'A') {
          return 1;
        } else if (orden1 == 'D') {
          return -1;
        } else {
          return 1;
        }
      } else if (a.toUpperCase() < b.toUpperCase()) {
        if (orden1 == 'A') {
          return -1;
        } else if (orden1 == 'D') {
          return 1;
        } else {
          return -1;
        }
      } else {
        return 0;
      }
    })
    return arreglo;
  }

  ordenarArregloDeObjetos(arreglo, campo1: string, orden1: string) {
    arreglo.sort((a: object, b: object) => {
      if (a[campo1].toUpperCase() > b[campo1].toUpperCase()) {
        if (orden1 == 'A') {
          return 1;
        } else if (orden1 == 'D') {
          return -1;
        } else {
          return 1;
        }
      } else if (a[campo1].toUpperCase() < b[campo1].toUpperCase()) {
        if (orden1 == 'A') {
          return -1;
        } else if (orden1 == 'D') {
          return 1;
        } else {
          return -1;
        }
      } else {
        return 0;
      }
    })
    return arreglo;
  }

  ordenarArregloDeObjetos2Campos(arreglo, campo1: string, campo2: string, orden1: string) {
    arreglo.sort((a: object, b: object) => {
      if ((a[campo1] > b[campo1]) || ((a[campo1] == b[campo1]) && (a[campo2] > b[campo2]))) {
        if (orden1 == 'A') {
          return 1;
        } else if (orden1 == 'D') {
          return -1;
        } else {
          return 1;
        }
      } else if ((a[campo1] < b[campo1]) || ((a[campo1] == b[campo1]) && (a[campo2] < b[campo2]))) {
        if (orden1 == 'A') {
          return -1;
        } else if (orden1 == 'D') {
          return 1;
        } else {
          return -1;
        }
      } else {
        return 0;
      }
    })
    return arreglo;
  }

  filtrarArregloDeObjetosPorCampo(arreglo, campo1: string, filtro: string, valor: string) {
    //El campo estado solo se filtra por el primer carácter del string, lo demás puede variar de empresa a empresa
    const arr2 = [];
    arreglo.map(a => {
      switch (filtro) {
        case '==':
          if (campo1 == 'estado') {
            if (a[campo1].toUpperCase().substring(0, 1) == valor.toUpperCase()) {
              arr2.push(a);
            }
          } else {
            if (a[campo1].toUpperCase() == valor.toUpperCase()) {
              arr2.push(a);
            }
          }
          break;
        case '!=':
          if (campo1 == 'estado') {
            if (a[campo1].toUpperCase().substring(0, 1) != valor.toUpperCase()) {
              arr2.push(a);
            }
          } else {
            if (a[campo1].toUpperCase() != valor.toUpperCase()) {
              arr2.push(a);
            }
          }
          break;
        default:
          break;
      }
    })
    return arr2;
  }

  buscarPacienteEnArregloPorCampo(arreglo: Paciente[], campo1: string, valor: string): Paciente {
    let obj: Paciente;
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i][campo1].toUpperCase() == valor.toUpperCase()) {
        obj = arreglo[i];
        break;
      }
    }
    return obj;
  }

  buscarPacienteIndiceEnArregloPorCampo(arreglo: PacienteIndice[], campo1: string, valor: string): PacienteIndice {
    let obj: PacienteIndice;
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i][campo1].toUpperCase() == valor.toUpperCase()) {
        obj = arreglo[i];
        break;
      }
    }
    return obj;
  }

  buscarArticuloEnArregloPorCampo(arreglo: Articulo[], campo1: string, valor: string): Articulo {
    let obj: Articulo;
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i][campo1].toUpperCase() == valor.toUpperCase()) {
        obj = arreglo[i];
        break;
      }
    }
    return obj;
  }

  buscarAtiendeEnArregloPorCampo(arreglo: Atiende[], campo1: string, valor: string): Atiende {
    let obj: Atiende;
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i][campo1].toUpperCase() == valor.toUpperCase()) {
        obj = arreglo[i];
        break;
      }
    }
    return obj;
  }

  buscarEntDiagEnArregloPorCampo(arreglo: EntDiag[], campo1: string, valor: string): EntDiag {
    let obj: EntDiag;
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i][campo1].toUpperCase() == valor.toUpperCase()) {
        obj = arreglo[i];
        break;
      }
    }
    return obj;
  }

  buscarEntProcEnArregloPorCampo(arreglo: EntProc[], campo1: string, valor: string): EntProc {
    let obj: EntProc;
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i][campo1].toUpperCase() == valor.toUpperCase()) {
        obj = arreglo[i];
        break;
      }
    }
    return obj;
  }

  buscarEntPresEnArregloPorCampo(arreglo: EntPres[], campo1: string, valor: string): EntPres {
    let obj: EntPres;
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i][campo1].toUpperCase() == valor.toUpperCase()) {
        obj = arreglo[i];
        break;
      }
    }
    return obj;
  }

  formatMoneda(val: number): string {
    const fmtMonedaUS = Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return fmtMonedaUS.format(val);
  }

  fEfectoSiNo(verSN: string): boolean {
    //default viene del parámetro verSINO: 
    //si es SI significa que el default es NO ver y solo para ciertos casos se puede ver
    //si es NO significa que el default es SI ver y solo para ciertos casos se oculta
    const verFinal: boolean = verSN == 'SI' ? false : true;
    return verFinal;
  }

  fEfectoUsr(usrPerm: string, usrActual: string): boolean {
    let verFinal: boolean = false;
    switch (usrPerm) {
      case 'Usr':
        if (usrActual == 'Usuario') {
          verFinal = true;
        }
        break;
      case 'Adm':
        if (usrActual == 'Admin') {
          verFinal = true;
        }
        break;
      case 'UsrAdm':
        verFinal = true;
        break;
      default:
        verFinal = false;
        break;
    }
    return verFinal;
  }

  /*
  fEfectoEstado(estPerm: string, estActual: string): boolean {
    let verFinal: boolean = false;
    switch (estPerm) {
      case '0':
        if (estActual == '0') {
          verFinal = true;
        }
        break;
      case '0-1':
        if ((estActual == '0') || (estActual == '1')) {
          verFinal = true;
        }
        break;
      case '1-2':
        if ((estActual == '1') || (estActual == '2')) {
          verFinal = true;
        }
        break;
      case '1-5':
        if ((estActual != '0') && (estActual != '6')) {
          verFinal = true;
        }
        break;
      case '6':
        if (estActual == '6') {
          verFinal = true;
        }
        break;
      default:
        verFinal = false;
        break;
    }
    return verFinal;
  }
  */

  /*
  accionPorTipoUsrYEstado(accSINO: string, tipoUPerm: string, estPerm: string, tipoUPerm2?: string, estPerm2?: string): boolean {
    //this.logService.consoleLog('2','CS FN ' + editSINO + tipoUPermitido + estPermitido + tipoUPermitido2 + estPermitido2);
    //default viene del parámetro accSINO: 
    //si es SI significa que el default es NO acción y solo si cumple las condiciones de tipoUsr y estado se puede acción
    //si es NO significa que el default es SI acción y solo si cumple las condiciones de tipoUsr y estado no se puede acción

    let accDefault: boolean;
    let condUsr: boolean;
    let condEst: boolean;
    let condUsr2: boolean;
    let condEst2: boolean;
    let accFinal: boolean;
    let estActual: string;

    //Cuando llamo a accionPorTipoUsrYEstado en estPerm envío un nemotécnico, como '0' o '1-5'.
    //En fEfectoEstado solo buscaré el número y compararé con el primer dígito que grabo en estActual
    estActual = this.dataPedidoService.pedidoElegido.estado.substring(0, 1);

    //obtengo default
    accDefault = this.fEfectoSiNo(accSINO);
    //Veo si cumple las condiciones 
    condUsr = this.fEfectoUsr(tipoUPerm, this.dataUserService.user.tipoUsuario);
    condEst = this.fEfectoEstado(estPerm, estActual);
    if (tipoUPerm2 != undefined && estPerm2 != undefined) {
      condUsr2 = this.fEfectoUsr(tipoUPerm2, this.dataUserService.user.tipoUsuario);
      condEst2 = this.fEfectoEstado(estPerm2, estActual);
    } else {
      condUsr2 = false;
      condEst2 = false;
    }
    //this.logService.consoleLog('2','CS FN ' + condUsr + ',' + condEst + ',' + condUsr2 + ',' + condEst2);
    accFinal = ((condUsr && condEst) || (condUsr2 && condEst2)) ? !accDefault : accDefault;
    return accFinal;
  }
  */

}
